import { apiClient } from '@api/client'
import { BodyMetricApi } from '@api/generated'

export const bodyMetricApi = new BodyMetricApi(undefined, '', apiClient)
